import React, { useEffect, useState } from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
	critical: {
		backgroundColor: '#dc2626',
		color: '#fff',
		fontWeight: 600,
	},
	warning: {
		backgroundColor: '#f59e0b',
		color: '#fff',
		fontWeight: 600,
	},
	chip: {
		marginRight: 12,
		height: 26,
	},
}));

// Re-render once a minute so the label tracks the real time remaining. Cheap:
// just a setState on a tick count; no network calls, no redux dispatch.
const useMinuteTick = () => {
	const [, setTick] = useState(0);
	useEffect(() => {
		const id = setInterval(() => setTick(t => t + 1), 60 * 1000);
		return () => clearInterval(id);
	}, []);
};

const TrialCountdownChip = () => {
	const classes = useStyles();
	const myOrganization = useSelector(({ organizations }) => organizations && organizations.organization && organizations.organization.myOrganization);
	useMinuteTick();

	if (!myOrganization || !myOrganization.license || !myOrganization.license.expiration) return null;

	const msLeft = new Date(myOrganization.license.expiration) - new Date();
	// Only surface the chip when less than 12 hours remain - beyond that the
	// countdown lives on the organization settings page. This keeps the nav
	// uncluttered for normal commercial usage and only nudges trial / demo
	// users who are genuinely close to expiry.
	const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;
	if (msLeft <= 0) return null;
	if (msLeft >= TWELVE_HOURS_MS) return null;

	const hours = Math.floor(msLeft / (60 * 60 * 1000));
	const minutes = Math.floor(msLeft / 60000);
	const label = hours >= 1 ? `${hours}h left` : `${Math.max(1, minutes)}m left`;
	const level = hours < 1 ? 'critical' : 'warning';

	return (
		<Tooltip title={`Trial ends at ${new Date(myOrganization.license.expiration).toLocaleString()}`}>
			<Chip
				size="small"
				label={label}
				className={`${classes.chip} ${level === 'critical' ? classes.critical : classes.warning}`}
			/>
		</Tooltip>
	);
};

export default TrialCountdownChip;
